"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MobileIdentityService_1 = __importDefault(require("../services/MobileIdentityService"));
var network_1 = __importDefault(require("../services/network"));
var Tracker_1 = __importDefault(require("../services/tracking/Tracker"));
var config_1 = __importDefault(require("../../config"));
var CampaignManager_1 = require("./CampaignManager");
var GrowCore_1 = require("./GrowCore");
var BrowseAbandonmentListener_1 = require("../listeners/BrowseAbandonmentListener");
var GrowCoreFactory = /** @class */ (function () {
    function GrowCoreFactory() {
    }
    GrowCoreFactory.buildGrowCore = function (user, script, services, logger, sessionManager) {
        var apis = (0, network_1.default)(logger, services.localStorage);
        var mobileIdentityService = new MobileIdentityService_1.default({
            user: user,
            sessionManager: sessionManager,
            localStorage: services.localStorage,
            logger: logger,
            api: apis.trackingApi,
            browserEnvironment: services.browserEnvironment
        });
        var tracker = new Tracker_1.default({
            environment: services.browserEnvironment,
            logger: logger,
            network: apis.trackingApi,
            storage: services.localStorage,
            sessionManager: sessionManager,
            userID: user.id
        });
        var campaignManager = new CampaignManager_1.CampaignManager({
            services: services,
            logger: logger,
            currentScript: script,
            sessionManager: sessionManager,
            tracker: tracker,
            userID: user.id,
            configurations: config_1.default
        });
        if (user.browseAbandonment) {
            (0, BrowseAbandonmentListener_1.registerBrowseAbandonmentListener)({
                api: apis.trackingApi,
                browseAbandonmentRules: user.browseAbandonment,
                environment: services.browserEnvironment,
                localStorage: services.localStorage,
                logger: logger,
                sessionManager: sessionManager,
                userID: user.id
            });
            (0, BrowseAbandonmentListener_1.handlePageChange)({
                api: apis.trackingApi,
                browseAbandonmentRules: user.browseAbandonment,
                environment: services.browserEnvironment,
                localStorage: services.localStorage,
                logger: logger,
                sessionManager: sessionManager,
                userID: user.id
            });
        }
        return new GrowCore_1.GrowCore({
            user: user,
            apis: apis,
            sessionManager: sessionManager,
            localStorage: services.localStorage,
            logger: logger,
            browserEnvironment: services.browserEnvironment,
            campaignManager: campaignManager,
            mobileIdentityService: mobileIdentityService
        });
    };
    return GrowCoreFactory;
}());
exports.default = GrowCoreFactory;
//# sourceMappingURL=data:application/json;base64,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